import miniToastr from 'mini-toastr';
import { positionFixedOverlayInView, startViewportInteractionTracking } from '../../_helpers/viewportOverlay.helper';

const defaultConfig = {
  timeout: 5000
}
const rawToastr = miniToastr.init(defaultConfig);

rawToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
rawToastr.setIcon('info', 'i', { 'class': 'fa fa-info-circle' })
rawToastr.setIcon('success', 'i', { 'class': 'fa fa-check-circle-o' })

startViewportInteractionTracking();

function placeToastrInView() {
  // mini-toastr appends asynchronously relative to the call; wait a frame so the node exists/has height.
  requestAnimationFrame(() => {
    positionFixedOverlayInView(document.getElementById('mini-toastr'));
  });
}

function wrapNotify(fn) {
  return function (...args) {
    const result = fn.apply(this, args);
    placeToastrInView();
    return result;
  };
}

const toastr = {
  ...rawToastr,
  error: wrapNotify(rawToastr.error.bind(rawToastr)),
  success: wrapNotify(rawToastr.success.bind(rawToastr)),
  info: wrapNotify(rawToastr.info.bind(rawToastr)),
  warn: wrapNotify(rawToastr.warn ? rawToastr.warn.bind(rawToastr) : rawToastr.info.bind(rawToastr)),
};

export { toastr };
